import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import Input from '../../../../components/shared/inputs/input';
import Select from '../../../../components/shared/inputs/select';
import Loader from '../../../../components/shared/loader';
import { WarrantyStage2FormFields } from '../../../../project/defines';
import { ordersApi } from '../../../../store/orders/ordersApi';
import { type WarrantyRequest } from '../../../../store/warrantyRequest/warrantyRequestModels';
import useTranslation from '../../../../utils/hooks/useTranslation';
import { useAppSelector } from 'store/hooks';
import { currentCountryUuid } from 'store/sideData/siteDataSlice';
import { useGetProductDefectsQuery } from 'store/sav/savApi';

const FieldsWarrantyArticle: React.FC<{ request: WarrantyRequest }> = ({ request }) => {
  const { t } = useTranslation();
  const {
    data: orders,
    isLoading: isOrdersLoading,
    isFetching: isOrdersFetching,
  } = ordersApi.endpoints.getProductOrders.useQueryState(request.produit_uuid!, { skip: !request?.produit_uuid });
  const orderOptions = useMemo(() => {
    const result = [{ value: '', text: t('garantie.demande.etapes.2.form.optionCommande') }];
    orders?.forEach((d) => result.push({ text: d.reference!, value: d.uuid }));
    return result;
  }, [orders, t]);

  const univers = useAppSelector((state) => state.siteData?.universInfo?.univers);
  const pays_uuid = useAppSelector(currentCountryUuid) ?? '';
  const lang = useAppSelector((state) => state.language.currentLanguage);
  const { data: productDefects,
      //isLoading: isDefectLoading,
      //isFetching: isDefectFetching,
     } = useGetProductDefectsQuery(
      { lang, pays_uuid, famille: null, produit: request?.produit_uuid, univers_uuid: univers?.uuid },
      { skip: !request?.produit_uuid || !univers?.uuid }
    );

  const defautOptions = useMemo(() => {
      //console.log(productDefects?.defauts);
      const result = [{ value: '', text: t('garantie.demande.etapes.2.form.optionDefaut') }];
      productDefects?.defauts?.forEach((d) => result.push({ text: d.libelle, value: d.uuid }));
      return result;
    }, [productDefects, t]);

  const { control, watch, setValue } = useFormContext();
  const dossier = watch(WarrantyStage2FormFields.dossier);
  const commande = watch('commande');

  useEffect(() => {
    setValue('commande', orders?.find((o) => o.reference === dossier)?.uuid ?? '');
  }, [dossier, setValue, orders]);

  useEffect(() => {
    if (commande) {
      const currentCommande = orders?.find((o) => o.uuid === commande);
      setValue(WarrantyStage2FormFields.dossier, currentCommande?.reference ?? commande);
    }
  }, [commande, setValue, orders]);

  //const deffect_uuid = watch(WarrantyStage2FormFields.defaut_uuid);
  
  return isOrdersLoading || isOrdersFetching ? (
    <Loader />
  ) : (
    <>
      <Input
        label="garantie.demande.etapes.2.form.ref_facture"
        dataLength="autofit"
        size="large"
        aria-invalid="false"
        placeholder={t('garantie.demande.etapes.2.form.ref_facture')}
        translateLabel
        isGroup
        name={WarrantyStage2FormFields.dossier}
        control={control}
      />
      <Select
        label="garantie.demande.etapes.2.form.commande"
        dataLength="autofit"
        size="large"
        aria-invalid="false"
        placeholder={t('garantie.demande.etapes.2.form.commande')}
        translateLabel
        options={orderOptions}
        isGroup
        name="commande"
        control={control}
      />
      <Select
        label="garantie.demande.etapes.2.form.defaut"
        dataLength="autofit"
        size="large"
        aria-invalid="false"
        placeholder={t('garantie.demande.etapes.2.form.defaut')}
        translateLabel
        options={defautOptions}
        isGroup
        name={WarrantyStage2FormFields.defaut_uuid}
        control={control}
      />
    </>
  );
};

export default FieldsWarrantyArticle;
